// src/pages/customer/OrderSuccess.jsx
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";
import { FiCheckCircle, FiPackage, FiArrowRight } from "react-icons/fi";

export default function OrderSuccess() {
  const { state } = useLocation();
  return (
    <div className="max-w-lg mx-auto px-4 py-20 text-center">
      <Helmet>
        <title>Order Placed | Tripura Agro</title>
        <meta
          name="description"
          content="Tripura Agro Industries was established in 2022 with the goal of leveraging supply and demand between farmers and Mandis at the national level and the final customer, who may be an individual or an institution."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <FiCheckCircle className="w-10 h-10 text-primary-600" />
      </div>
      <h1 className="font-display text-3xl font-bold text-gray-900 mb-3">Order Placed!</h1>
      <p className="text-gray-600 mb-2">Thank you for your order. We'll confirm it shortly.</p>
      {state?.orderId && (
        <p className="text-sm text-gray-500 mb-8">Order ID: <span className="font-mono font-medium text-gray-800">{state.orderId.slice(0, 12).toUpperCase()}</span></p>
      )}
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/orders" className="btn-primary flex items-center justify-center gap-2">
          <FiPackage className="w-4 h-4" /> Track Orders
        </Link>
        <Link to="/products" className="btn-secondary flex items-center justify-center gap-2">
          Continue Shopping <FiArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}